import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import Color from '@tiptap/extension-color';
import { TextAlign } from '@tiptap/extension-text-align';
import { Link } from '@tiptap/extension-link';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';
import MenuBar from './MenuBar';
import ListItem from '@tiptap/extension-list-item';
import './Editor.scss';

const CustomListItem = ListItem.extend({
	addGlobalAttributes() {
		return [
			{
				types: ['listItem'],
				attributes: {
					style: {
						default: '',
					},
				},
			},
		];
	},
});

const Editor = props => {
	const { value, onChange, theme, widgetToUpdate, widgets, preview } = props;

	const editor = useEditor({
		extensions: [
			StarterKit.configure({
				heading: {
					levels: [1, 2, 3],
				},
				listItem: false,
			}),
			TextStyle,
			Underline,
			CustomListItem,
			Color,
			Superscript,
			Subscript,
			TextAlign.configure({
				types: ['paragraph', 'heading'],
			}),
			Link.configure({
				openOnClick: false,
			}),
		],
		content: value,
		onUpdate: ({ editor }) => onChange(editor.view.dom.innerHTML), // preserves empty paragraphs as opposed to editor.getHTML()
	});

	useEffect(() => {
		if (editor && value && value !== editor.view.dom.innerHTML) {
			// removes extra br tag tiptap adds https://github.com/ueberdosis/tiptap/issues/1500
			let cleanedHtml = value.replace(/<br\s*class=["']ProseMirror-trailingBreak["']\s*\/?>/g, '');
			editor.commands.setContent(cleanedHtml);
		}
	}, [editor, value]);

	const background =
		theme && theme.background_src
			? {
					backgroundImage: `url(${theme.background_src})`,
					objectFit: 'contain',
					objectPosition: '-25% 25%',
					height: 'min-content',
			  }
			: { backgroundColor: theme.background_color || '#FFFFFF' };

	//approximate background position by widgetToUpdate position
	const position = widgets.findIndex(widget => widget.id === widgetToUpdate.id);
	const sizeToMove = preview === 'tablet' ? 260 : preview === 'phone' ? 400 : 100;
	const backgroundPosition = `0 -${position * sizeToMove}px`;

	return editor ? (
		<div className="Editor">
			{/* {editor.isFocused && <MenuBar editor={editor} />} */}
			<MenuBar editor={editor} />

			<EditorContent
				editor={editor}
				className="tiptap-container"
				style={{ ...background, backgroundPosition }}
			/>
		</div>
	) : null;
};

const msp = ({ widgets }) => ({
	widgets,
});

export default connect(msp, null)(Editor);
